// 订单状态
const ORDER_STATUS_MAP = new Map([
  [0, 'Unpaid'],
  [1, 'Paid'],
  [2, 'Cancelled'],
  [3, 'Shipped'],
  [4, 'Partial Shipped'],
  // [5, 'Received'],
  [5, 'Fulfilled'],
  [6, 'Refund under review'],
  [7, 'Refunded'],
  [8, 'Declined on Refund'],
  [9, 'Partial refund'],
  [10, 'Processing'],
  [11, 'Failed'],
  [13, 'Returning'],
  [16, 'Refunding'],
  [23, 'Return completed'],
  [24, 'Complete partially'],
  // [31, 'On Hold'],
  [40, 'Packaging'],
  // [42, 'Canceled'],
  [42, 'Closed'],
  // [52, 'Partial Delivered'],
  // [53, 'Delivered'],
  // [54, 'Partial Received'],
  [52, 'Shipped'],
  [53, 'Shipped'],
  [54, 'Shipped'],
  [99, 'Closed']
])

export function getOrderStateDesc(statusCode) {
  return ORDER_STATUS_MAP.get(statusCode)
}



// WEBPACK FOOTER //
// ./src/utils/status.js